import { Link, useLocation } from "react-router-dom";
import { Plus, List } from "lucide-react";

export const Header = () => {
  const location = useLocation();
  const onCreate = location.pathname.startsWith("/nuevo");

  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-slate-200 no-print">
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex flex-col leading-none">
          <h1 className="text-2xl md:text-3xl font-black tracking-tight bg-gradient-to-r from-blue-500 to-emerald-500 bg-clip-text text-transparent">
            ENDLESS COMPUTER
          </h1>
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-slate-400 mt-0.5">
            Albaranes de recogida y entrega
          </span>
        </Link>
        <nav className="flex items-center gap-2">
          <Link
            to="/"
            data-testid="nav-list-link"
            className={`hidden sm:inline-flex items-center gap-1.5 h-10 px-3 rounded-lg text-sm font-semibold transition-colors ${
              !onCreate ? "bg-slate-100 text-slate-900" : "text-slate-500 hover:bg-slate-100"
            }`}
          >
            <List className="h-4 w-4" /> Albaranes
          </Link>
          <Link
            to="/nuevo"
            data-testid="nav-create-link"
            className="inline-flex items-center gap-1.5 h-10 px-4 rounded-lg text-sm font-bold text-white bg-blue-500 hover:bg-blue-600 transition-colors"
          >
            <Plus className="h-4 w-4" /> Nuevo
          </Link>
        </nav>
      </div>
    </header>
  );
};
